module.exports = "precision highp float;\n#define GLSLIFY 1\nuniform vec2 strength;\nuniform vec2 center;\nuniform vec2 scale;\nvarying vec2 uv;\nvoid main ()\n{\n  vec2 x_1;\n  x_1 = ((uv - center) / scale);\n  mediump vec4 tmpvar_2;\n  tmpvar_2.zw = vec2(0.0, 1.0);\n  tmpvar_2.xy = (strength * (1.0 - min (\n    sqrt(dot (x_1, x_1))\n  , 1.0)));\n  gl_FragColor = tmpvar_2;\n}\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/addstrength.frag
// module id = 303
// module chunks = 0